import { SvgIcon, SvgIconProps } from '@mui/material'

// #moghavemat
export const NotifOffIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
      <path
        d="M32 58.6667C34.9333 58.6667 37.3333 56.2668 37.3333 53.3334H26.6667C26.6667 56.2668 29.0667 58.6667 32 58.6667ZM32 17.3334C38.64 17.3334 42.6667 22.7201 42.6667 29.3334V29.6001L48 34.9334V29.3334C48 21.1467 43.6533 14.2934 36 12.4801V10.6667C36 8.45341 34.2133 6.66675 32 6.66675C29.7867 6.66675 28 8.45341 28 10.6667V12.4801C27.36 12.6401 26.7467 12.8801 26.16 13.0934L30.5333 17.4667C31.0133 17.4134 31.4933 17.3334 32 17.3334ZM14.4267 8.93341L10.6667 12.6934L18.16 20.1867C16.7733 22.8534 16 25.9734 16 29.3334V42.6667L10.6667 48.0001V50.6667H48.64L53.28 55.3067L57.04 51.5467L14.4267 8.93341ZM42.6667 45.3334H21.3333V29.3334C21.3333 27.5201 21.6533 25.8134 22.24 24.2668L42.6667 44.6934V45.3334Z"
        fill="#D02128"
      />
    </SvgIcon>
  )
}
